<template>
  <hm-content title="">
    <div class="table-panel flex flex-end">
      <el-select
        size="small"
        clearable
        placeholder="请选择储值卡"
        v-model="searchCondition.cardId"
        filterable
        class="mr10"
      >
        <el-option
          :label="v.cardName"
          :value="v.cardId"
          v-for="(v, i) in cardAllList"
          :key="i"
        ></el-option>
      </el-select>
      <el-select
        size="small"
        clearable
        placeholder="获得方式"
        v-model="searchCondition.sourceType"
        class="mr10"
      >
        <el-option label="购买" value="buy"></el-option>
        <el-option label="赠送" value="give"></el-option>
      </el-select>
      <el-select
        size="small"
        clearable
        placeholder="卡状态"
        v-model="searchCondition.cardStatus"
        class="mr10"
      >
        <el-option label="正常" value="ok"></el-option>
        <el-option label="冻结" value="frozen"></el-option>
        <el-option label="锁定" value="lock"></el-option>
      </el-select>
      <el-input
        clearable
        v-model.trim="searchCondition.queryValue"
        placeholder="请输入"
        size="small"
        style="width: 300px"
        class="ipt mr10"
      >
        <el-select
          slot="prepend"
          style="width: 100px"
          v-model="searchCondition.queryKey"
          size="small"
        >
          <el-option label="持卡人姓名" value="memberName"></el-option>
          <el-option label="持卡人卡号" value="cardNo"></el-option>
          <el-option label="持卡人电话" value="memberMobile"></el-option>
        </el-select>
      </el-input>
      <el-input
        clearable
        style="width: 200px"
        v-model.trim="searchCondition.sourceReceiptSn"
        placeholder="请输入购卡订单号"
        size="small"
        class="ipt mr10"
      >
      </el-input>
      <el-date-picker
        style="width: 300px"
        v-model="searchCondition.createTimeArry"
        :default-time="['00:00:00', '23:59:59']"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="datetimerange"
        align="right"
        size="small"
        class="mr10"
        unlink-panels
        start-placeholder="请选择购买时间段"
        end-placeholder="请选择购买时间段"
      >
      </el-date-picker>
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button
        type="success"
        size="small"
        @click="output('queryAllList', '储值卡销售明细')"
        >导出</el-button
      >
    </div>
    <div>
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardName"
          label="储值卡名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="持卡人姓名"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardNo"
          label="持卡人卡号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="持卡人电话"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardStatus"
          label="卡状态"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.level === 1">--</div>
            <div v-else>
              <div v-if="scope.row.cardStatus === 'frozen'" class="danger">
                冻结
              </div>
              <div v-if="scope.row.cardStatus === 'lock'" class="blue">
                锁定
              </div>
              <div v-if="scope.row.cardStatus === 'ok'" class="success">
                正常
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="sourceType"
          label="获得方式"
        >
          <template slot-scope="scope">
            {{ scope.row.sourceType === "buy" ? "购买" : "赠送" }}
            <div v-if="scope.row.sourceType === 'give'">
              <el-button type="text" size="small" @click="giveInfo(scope.row)">
                赠送来源
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="sourceReceiptSn"
          label="购卡订单号"
        >
          <template slot-scope="scope">
            {{ scope.row.sourceReceiptSn }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardSalePrice"
          label="储值卡售价"
        >
          <template slot-scope="scope">
            <div class="primary">{{ scope.row.cardSalePrice }}元</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardDenomination"
          label="储值卡面额"
        >
          <template slot-scope="scope">
            <div class="primary">{{ scope.row.cardDenomination }}元</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardBalance"
          label="储值卡余额"
        >
          <template slot-scope="scope">
            <div class="primary">{{ scope.row.cardBalance }}元</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardStartTime"
          label="购买时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardsTime"
          label="储值卡有效期"
          width="150"
        >
          <template slot-scope="scope">
            {{ scope.row.cardStartTime }}至{{ scope.row.cardEndTime }}
          </template>
        </el-table-column>

        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                size="small"
                type="text"
                class="success"
                v-if="scope.row.cardStatus === 'frozen'"
                @click="frozen(scope.row)"
                :disabled="scope.row.cardStatus === 'lock'"
              >
                解冻</el-button
              >
              <el-button
                size="small"
                type="text"
                class="danger"
                v-if="scope.row.cardStatus === 'ok'"
                @click="frozen(scope.row)"
                :disabled="scope.row.cardStatus === 'lock'"
              >
                冻结</el-button
              >
            </div>
            <el-button
              size="small"
              type="text"
              class="blue"
              @click="useDetails(scope.row)"
            >
              卡使用明细</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="赠送来源"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="600px"
    >
      <el-table
        stripe
        border
        ref="table"
        :data="[info]"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="赠送人电话"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardNo"
          label="赠送人卡号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="赠送人姓名"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="giveTime"
          label="赠送时间"
        >
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      title="卡使用明细"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleUse"
      width="800px"
    >
      <div class="flex flex-end">
      <el-button
        type="success"
        size="small"
        @click="output('queryAllCardDetails', '卡使用明细')"
        >导出</el-button
      >
      </div>
      <el-table
        stripe
        border
        ref="table"
        :data="cardUseDetails"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPageUse - 1) * pageSizeUse + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderId"
          label="使用方式"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.orderId === 'hexiao'">
              手动核销
            </div>
            <div v-else>
              {{scope.row.orderId}}
            </div>
            <!-- {{ scope.row.orderId === "hexiao" ? "手动核销" : "订单使用" }} -->
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="receiptSn"
          label="使用单号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="usedMoney"
          label="储值卡金额"
        >
        <template slot-scope="scope">
          <span v-if="scope.row.usedMoney > 0">-{{Math.abs(scope.row.usedMoney)}}</span>
          <span v-else-if="scope.row.usedMoney < 0">+{{Math.abs(scope.row.usedMoney)}}</span>
          <span v-else>{{scope.row.usedMoney}}</span>
        </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="operTime"
          label="使用时间"
        >
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="totalUse"
          @current-change="pagingUse"
          @size-change="handleSizeChangeUse"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPageUse"
        ></el-pagination>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      searchCondition: {
        queryKey: "memberName"
      },
      info: {},
      dialogVisibleUse: false,
      dialogVisible: false,
      cardUseDetails: [],
      currentPageUse: 1,
      pageSizeUse: 10,
      totalUse: 0,
      currentPage: 1,
      pageSize: 10,
      list: [],
      total: 0,
      cardAllList: [],
      isOutputing: false
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
    this.queryPrepayCardList();
  },
  methods: {
    async giveInfo(row) {
      const { code, result } = await this.$store.dispatch(
        "queryStorePrepayCardMemberRelGiveFromInfo",
        {
          cardRelId: row.cardRelId
        }
      );
      if (code === "0") {
        this.dialogVisible = true;
        this.info = result;
      }
    },
    useDetails(row) {
      this.row = row;

      this.queryCardDetails();
    },
    async queryCardDetails() {
      let params = {
        pageNo: this.currentPageUse,
        pageSize: this.pageSizeUse,
        cardRelId: this.row.cardRelId
      };
      const { result } = await this.$store.dispatch(
        "queryPrepayCardUsedRecordList",
        params
      );
      this.dialogVisibleUse = true;
      const { records, total } = result;
      this.cardUseDetails = records;
      this.totalUse = total;
    },
    async queryAllCardDetails() {
      let params = {
        pageNo: 1,
        pageSize: 9999,
        cardRelId: this.row.cardRelId
      };
      const { result } = await this.$store.dispatch(
        "queryPrepayCardUsedRecordList",
        params
      );
      return result.records;
    },
    async frozen(row) {
      let params = JSON.parse(JSON.stringify(row));
      if (row.cardStatus === "ok") {
        params.cardStatus = "frozen";
      } else if (row.cardStatus === "frozen") {
        params.cardStatus = "unfreeze";
      }
      const { code } = await this.$store.dispatch(
        "frozenPrepayCardOrder",
        params
      );
      if (code === "0") {
        this.$message({
          message: " 操作成功",
          type: "success"
        });
        this.queryList();
      }
    },
    async queryPrepayCardList() {
      let params = {
        pageNo: 1,
        pageSize: 9999,
        auditStatus: "agree"
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryPrepayCardList",
        params
      );
      this.cardAllList = result.records;
    },
    async queryAllList() {
      let params = {
        pageNo: 1,
        pageSize: 99999
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.queryStartTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[0]
          : null;
      searchCondition.queryEndTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[1]
          : null;
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryAllStorePrepayCardMemberRelList",
        params
      );
      return result.records;
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.queryStartTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[0]
          : null;
      searchCondition.queryEndTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[1]
          : null;
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryStorePrepayCardMemberRelList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    // 导出excel
    output(funcName, title) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        const func = this[funcName];
        func()
          .then(res => {
            const list = res;
            list.forEach(v => {
              if (v.level === 1) {
                v.cardStatus = "--";
              } else {
                if (v.cardStatus === "frozen") {
                  v.cardStatus = "冻结";
                } else if (v.cardStatus === "lock") {
                  v.cardStatus = "锁定";
                } else if (v.cardStatus === "ok") {
                  v.cardStatus = "正常";
                }
              }
              if (v.sourceType === "buy") {
                v.sourceType = "购买";
              } else {
                v.sourceType = "赠送";
              }
              v.cardsTime = v.cardStartTime + "至" + v.cardEndTime;
              if(v.cardSalePrice){
                v.cardSalePrice = v.cardSalePrice + "元";
              }
              if(v.cardDenomination){
                v.cardDenomination = v.cardDenomination + "元";
              }
              if(v.cardBalance){
                v.cardBalance = v.cardBalance + "元";
              }
              if(v.orderId){
                if(v.usedState === 'refund'){
                  v.orderId = "退款退还";
                }else if(v.orderId === 'hexiao'){
                  v.orderId = "手动核销";
                }else if(v.orderId === '线下退储值卡'){
                  v.orderId = "线下退储值卡";
                }else if(v.orderId === '线下购物'){
                  v.orderId = "线下购物";
                }else{
                  v.orderId = "订单使用";
                }
              }
            });
            if(funcName==='queryAllList' && list.length > 0){
              const tHeader = [
                "储值卡名称",
                "持卡人姓名",
                "持卡人卡号",
                "持卡人电话",
                "卡状态",
                "获得方式",
                "购卡订单号",
                "储值卡售价",
                "储值卡面额",
                "储值卡余额",
                "购买时间",
                "储值卡有效期"
              ];
              const filterVal = [
                "cardName",
                "memberName",
                "cardNo",
                "memberMobile",
                "cardStatus",
                "sourceType",
                "sourceReceiptSn",
                "cardSalePrice",
                "cardDenomination",
                "cardBalance",
                "cardStartTime",
                "cardsTime"
              ];
              const data = this.formatJson(filterVal, list);
              exportJsonToExcel(
                tHeader,
                data,
                title + new Date().toLocaleString()
              );
              this.isOutputing = false;    
            }else if(funcName==='queryAllCardDetails' && list.length > 0){
              const tHeader = [
                "使用方式",
                "使用单号",
                "储值卡金额",
                "使用时间"
              ];
              const filterVal = [
                "orderId",
                "receiptSn",
                "usedMoney",
                "operTime"
              ]   
              const data = this.formatJson(filterVal, list);
              exportJsonToExcel(
                tHeader,
                data,
                title + new Date().toLocaleString()
              );
              this.isOutputing = false;    
            }  
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    pagingUse(page) {
      this.currentPageUse = page;
      this.queryCardDetails();
    },
    handleSizeChangeUse(size) {
      this.currentPageUse = 1;
      this.pageSizeUse = size;
      this.queryCardDetails();
    }
  }
};
</script>
<style lang="scss" scoped></style>
